import { ROLES } from 'src/types/Employee';

export type ROLES_OPTION = { text: string; value: ROLES };
export const ROLES_LIST: ROLES_OPTION[] = [
  {
    value: ROLES.DINER,
    text: 'Standard User',
  },
  {
    value: ROLES.ADMIN,
    text: 'Admin User',
  },
  {
    value: ROLES.FINANCIAL_ADMIN,
    text: 'Business Financial Admin',
  },
];
